const UNDERWRITING_STATUSES = ['awaitingResponse', 'expectationsCall', 'packaging', 'pendingFundingManager', 'offerReceived', 'offerToBorrower'];
const BLACKLISTED_AUTOSUB_TYPES = ['optin', 'ppp', 'random', 'score', 'instant', 'automation', 'cupcake'];

export {
  UNDERWRITING_STATUSES,
  BLACKLISTED_AUTOSUB_TYPES,
};
